import React, {FC} from 'react';

import {buildInteractionIdProps} from '../../../../../libs/shared/core/src/helpers/interaction/interactionHelpers';
import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {openInBrowser} from '../../../../../srcCommon/browser/openInBrowser';
import {SetupGuideTask, SetupGuideTaskProps} from '../common/setupGuideTask';

/*
 * Constants.
 */

// We must attach data-testid attribute to an element as an anchor for our Pendo Guide.
const interactionId = 'accounts-setup-guide-discover-front-accounts';

const helpCenterUrl = 'https://help.front.com/t/h7h1h2s/customer-beta-understanding-front-accounts';

/*
 * Props.
 */

type DiscoverFrontAccountsTaskProps = Omit<SetupGuideTaskProps, 'label' | 'onClick'>;

/*
 * Component.
 */

/**
 * This task is marked as complete by default, as the Pendo guide will always be displayed when
 * it is rendered for the first time.
 *
 * This decision was made to simplify the initial release of the Accounts Setup Guide, as our Pendo
 * service cannot be used to manually trigger an already dismissed guide or check dismissal status
 * of an existing guide.
 */
export const DiscoverFrontAccountsTask: FC<DiscoverFrontAccountsTaskProps> = ({isComplete}) => (
  <span {...buildInteractionIdProps(interactionId)}>
    <SetupGuideTask
      label={<Trans id="accounts-setup-guide-task-discover-front-accounts">Discover Front Accounts</Trans>}
      isComplete={isComplete}
      onClick={() => openInBrowser(helpCenterUrl)}
    />
  </span>
);
